// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M4 7.16999L10.59 0.579987L12 1.99999L4 9.99999L0 5.99999L1.41 4.58999L4 7.16999Z%27 fill=%27white%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section--content .boxIntro {
    text-align: left;
    display: flex;
    align-items: center;
    gap: 2rem;
    max-width: 70rem;
    width: 100%;
    justify-content: space-between;
    margin: 2rem 0;
}

.boxIntro .intro {
    max-width: 31rem;
    flex: 1;
}

.boxIntro .list {
    display: flex;
    gap: 1rem;
    color: #666;
    margin: 2rem 0;
}

.boxIntro .list svg {
    flex: none;
}

.boxIntro .boxLogos {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
}

.boxIntro .boxLogos svg {
    height: 50px;
    width: auto;
}

.boxIntro .boxLogos .TrovitLogo {
    height: 25px;
}

.boxIntro .boxLogos .MitulaLogo {
    height: 21px;
}

.boxIntro .boxLogos .NestoriaLogo {
    height: 23px;
}

.boxIntro .boxLogos .NuroaLogo {
    height: 40px;
}

.boxIntro .form {
    background-color: #3181F7;
    color: #FFF;
    border-radius: 1rem;
    padding: 1.5rem;
    box-shadow: 3px 6px 15px rgba(0, 0, 0, 0.15);
    max-width: 25rem;
    flex: 1;
}

.boxIntro .form a {
    color: #FFF;
}

.boxIntro .form a:hover {
    color: #000;
}

.boxIntro .form h3 {
    font-size: 1.5rem;
    margin: 1rem 0;
}

.boxIntro .form .formContact {
    margin-top: 2rem;
}

.boxIntro .formSuccess {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.boxIntro .formSuccess .arrowBackButton {
    width: 1.71rem;
    align-self: flex-start;
    padding: 1.14rem 0;
    background: none;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}

.boxIntro .formSuccess .partyPopperEmoji {
    font-size: 8.14rem;
    margin-top: 4rem;
}

.boxIntro .formSuccess .formSuccess__title {
    font-size: 1.71429rem;
    font-weight: 700;
    margin: 1.71rem 0;
}

.boxIntro .formSuccess .formSuccess__description {
    font-size: 1.57143rem;
    font-weight: 400;
}

.boxIntro .formSuccess .formSuccess__button {
    padding: 0.67rem 1.04rem;
    margin: 2.85rem 0;
}


@media (max-width: 769px) {
    .boxIntro {
        flex-direction: column-reverse;
        align-items: stretch;
    }

    .boxIntro .intro {
        max-width: 100%;
    }

    .boxIntro .form {
        max-width: 100%;
    }

    .boxIntro .boxLogos {
        gap: 1rem 2rem;
        width: 17rem;
        margin: 0 auto;
    }
}

.checkboxForm {
    font-size: 0.75rem;
    margin-bottom: 1.5rem;
}

.checkboxForm input[type=checkbox] {
    position: absolute;
    opacity: 0;
}

.checkboxForm label {
    padding-left: 2rem;
    position: relative;
    width: initial;
}

.checkboxForm label span {
    line-height: 1.5;
    font-weight: 400;
}

.checkboxForm input[type=checkbox] + span::before {
    content: "";
    padding: 0;
    min-width: inherit;
    background-color: #fff;
    display: block;
    width: 14px;
    height: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    position: absolute;
    top: 0;
    z-index: 1;
    left: 1px;
}

.checkboxForm input[type=checkbox] + span::after {
    content: "";
    padding: 0;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 2px;
    left: 3px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
    opacity: 0;
}

.checkboxForm input[type=checkbox]:checked + span::before {
    background-color: #333;
    border-color: rgba(0, 0, 0, 0.15);
}

.checkboxForm input[type=checkbox]:checked + span::after {
    opacity: 1;
}

.checkboxForm input[type=checkbox].error + span::before {
    outline: 2px solid #C00;
}

.checkboxForm input[type=checkbox]:focus + span::before {
    outline: 2px solid #333;
}`, "",{"version":3,"sources":["webpack://./js/pages/Homepage/Main/ContactUs/ContactUs.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;;AAGA;IACI;QACI,8BAA8B;QAC9B,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yDAAsQ;IACtQ,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;IACV,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".section--content .boxIntro {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    max-width: 70rem;\n    width: 100%;\n    justify-content: space-between;\n    margin: 2rem 0;\n}\n\n.boxIntro .intro {\n    max-width: 31rem;\n    flex: 1;\n}\n\n.boxIntro .list {\n    display: flex;\n    gap: 1rem;\n    color: #666;\n    margin: 2rem 0;\n}\n\n.boxIntro .list svg {\n    flex: none;\n}\n\n.boxIntro .boxLogos {\n    display: flex;\n    gap: 1rem;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.boxIntro .boxLogos svg {\n    height: 50px;\n    width: auto;\n}\n\n.boxIntro .boxLogos .TrovitLogo {\n    height: 25px;\n}\n\n.boxIntro .boxLogos .MitulaLogo {\n    height: 21px;\n}\n\n.boxIntro .boxLogos .NestoriaLogo {\n    height: 23px;\n}\n\n.boxIntro .boxLogos .NuroaLogo {\n    height: 40px;\n}\n\n.boxIntro .form {\n    background-color: #3181F7;\n    color: #FFF;\n    border-radius: 1rem;\n    padding: 1.5rem;\n    box-shadow: 3px 6px 15px rgba(0, 0, 0, 0.15);\n    max-width: 25rem;\n    flex: 1;\n}\n\n.boxIntro .form a {\n    color: #FFF;\n}\n\n.boxIntro .form a:hover {\n    color: #000;\n}\n\n.boxIntro .form h3 {\n    font-size: 1.5rem;\n    margin: 1rem 0;\n}\n\n.boxIntro .form .formContact {\n    margin-top: 2rem;\n}\n\n.boxIntro .formSuccess {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.boxIntro .formSuccess .arrowBackButton {\n    width: 1.71rem;\n    align-self: flex-start;\n    padding: 1.14rem 0;\n    background: none;\n    color: inherit;\n    border: none;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit;\n}\n\n.boxIntro .formSuccess .partyPopperEmoji {\n    font-size: 8.14rem;\n    margin-top: 4rem;\n}\n\n.boxIntro .formSuccess .formSuccess__title {\n    font-size: 1.71429rem;\n    font-weight: 700;\n    margin: 1.71rem 0;\n}\n\n.boxIntro .formSuccess .formSuccess__description {\n    font-size: 1.57143rem;\n    font-weight: 400;\n}\n\n.boxIntro .formSuccess .formSuccess__button {\n    padding: 0.67rem 1.04rem;\n    margin: 2.85rem 0;\n}\n\n\n@media (max-width: 769px) {\n    .boxIntro {\n        flex-direction: column-reverse;\n        align-items: stretch;\n    }\n\n    .boxIntro .intro {\n        max-width: 100%;\n    }\n\n    .boxIntro .form {\n        max-width: 100%;\n    }\n\n    .boxIntro .boxLogos {\n        gap: 1rem 2rem;\n        width: 17rem;\n        margin: 0 auto;\n    }\n}\n\n.checkboxForm {\n    font-size: 0.75rem;\n    margin-bottom: 1.5rem;\n}\n\n.checkboxForm input[type=checkbox] {\n    position: absolute;\n    opacity: 0;\n}\n\n.checkboxForm label {\n    padding-left: 2rem;\n    position: relative;\n    width: initial;\n}\n\n.checkboxForm label span {\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n.checkboxForm input[type=checkbox] + span::before {\n    content: \"\";\n    padding: 0;\n    min-width: inherit;\n    background-color: #fff;\n    display: block;\n    width: 14px;\n    height: 14px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    position: absolute;\n    top: 0;\n    z-index: 1;\n    left: 1px;\n}\n\n.checkboxForm input[type=checkbox] + span::after {\n    content: \"\";\n    padding: 0;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    top: 2px;\n    left: 3px;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 7.16999L10.59 0.579987L12 1.99999L4 9.99999L0 5.99999L1.41 4.58999L4 7.16999Z' fill='white'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: center;\n    z-index: 1;\n    opacity: 0;\n}\n\n.checkboxForm input[type=checkbox]:checked + span::before {\n    background-color: #333;\n    border-color: rgba(0, 0, 0, 0.15);\n}\n\n.checkboxForm input[type=checkbox]:checked + span::after {\n    opacity: 1;\n}\n\n.checkboxForm input[type=checkbox].error + span::before {\n    outline: 2px solid #C00;\n}\n\n.checkboxForm input[type=checkbox]:focus + span::before {\n    outline: 2px solid #333;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
